import './index.css';
import Iframe from './iframe';
import reportWebVitals from './reportWebVitals';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// ----------------------------------------------------------------------
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <Router basename="/chatbot-iframes">
    <Routes>
      <Route path="/" element={<span>Burstyai.com</span>} />
      <Route path="/:publicUUID/:businessAccountId/:projectId/:agentId" element={<Iframe />} />
      <Route path="/:publicUUID/:businessAccountId/:projectId/:agentId/:type" element={<Iframe innerScriptType={"chatbot"}/>} />
    </Routes>
  </Router>

);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();



// import React from 'react';
// import ReactDOM from 'react-dom';
// import ChatBot from './ChatBot';

// export function renderChatBot(containerId) {
//   ReactDOM.render(<ChatBot />, document.getElementById(containerId));
// }
